module.exports = __webpack_public_path__ + "static/img/-s-icon yanzheng (2).5aa0d72a.svg";